export const locales = ['en', 'de', 'fi', 'es', 'fr', 'it', 'ja'];
